<template>
  <div>
    <NavTop class="navbar">
    </Navtop>
    <!-- 轮播图 -->
    <div class="block">
      <el-carousel trigger="click" height="450px">
        <el-carousel-item v-for="item in 4" :key="item" :interval = '5000'>
          <h3 class="small">{{ item }}</h3>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="center" ref="targetDiv">
      <div class="left_box">
        <!-- 左侧导航框 -->
        <aside class="sidebar">
          <div class="left_title">
            <div>
              学校概况
            </div>
            <div>
              ABOUT CUEB
            </div>
          </div>
          <ul class="nav">
            <li v-for="(item, index) in navItems" :key="index"  @click="navigateTo(item.path)">
              {{ item.name }}
            </li>
          </ul>
        </aside>
      </div>
      <div class="right_box">
        <div class="row between border_bottom">
          <div class="title"><h3>现任领导</h3></div>
          <div class="right_link"><router-link to="/" class="link" >首页</router-link>/ <router-link to="/profiles" class="link" >学校概况</router-link>/<router-link to="/leader" class="link" >现任领导</router-link> </div>
        </div>
        <div class="txt">
          河北东方学院是教育部批准设立的一所民办地方性应用型本科高校，地处京津走廊——河北省廊坊市东方大学城，距北京天安门46公里，占据了得天独厚的地缘优势。学校建有省级博物馆、校内艺术馆、高尔夫练习馆、网球馆、游泳馆等。是周杰伦歌曲《浪漫手机》MV的拍摄地，是张艺谋导演的电影《第二十条》的取景地。校园四季如画，欧式建筑别具风格。

          学校现有全日制在校生33,000余人，设有7个二级学院，文物艺术学院、数字传媒学院、人工智能学院、医学院、经济管理学院、人文学院、马克思主义学院。开设28个本科专业，涵盖艺术学、历史学、工学、经济学、管理学、文学、医学、教育学八个学科门类。形成了以文物艺术为特色，以人工智能技术为引领的文理交融，专业互通，相互支撑的学科专业布局。

          学校坚持“文化引领、立德树人”，为党育人，为国育才。是“中华优秀传统文化教育研究实践基地”、“全国高校美育教学实践基地”、“全国五四红旗团支部”。培养了见义勇为的好学生李浩、李海鹏，培养了“全国高校毕业生基层就业卓越奖”获得者海涛。是河北省版权示范单位、河北省众创空间，平均每年都有4000多件师生作品获得版权登记或专利，享有创新知识产权。《2024年ABC中国民办大学排名》学校位列第73名，2023校友会《中国大学一流专业排名（应用型）》学校文物与博物馆学和文物保护与修复专业分别位列第2名和第3名。

          学校坚持“专家引领、名师执教”，形成了专家支撑专业建设和人才培养的基本格局。引进了一批享受国务院、政府特殊津贴的专家和学者及博士生导师、当代知名艺术家、企业家、技术大师、非遗传承人等行业领军人物担纲专业带头人。目前学校有5个省级一流专业，11门省级一流课程和精品在线开放课程，3个省级优秀教师团队和多名省级教学名师、1个省级高校优秀基层教学组织、21个省级高校达标基层教学组织。教师在河北省高校教师教学创新大赛和西浦全国大学教学创新大赛中屡创佳绩。是河北省实验教学和教学实验室建设研究项目立项单位，是教育部高等学校虚拟仿真教学创新实验室项目立项单位，是教育部全国应用型人才培养基地。

          学校坚持“产教融合、校企一体”，实现了人才培养供给侧和产业需求侧的高度耦合。与中国文物保护技术协会、国家博物馆、北京国博文化遗产研究院等深度合作，建设了省内高校首家具有省文物局认定资质的“文物保护修复综合技术中心”，秉持“文物+艺术+科技”的人才培养理念，采取基于项目的教育与学习，实现了知识和能力的同步培养。

          引企入校，把企业资源与学校资源有效整合，学校与企业变成了“共同体”，对学生实行“一体化合作培养”。引进北京正元特道科技有限公司，为数字传媒人才培养建设了校内外实训基地。引进北京精准高尔夫培训机构，合作成立高尔夫产业学院，共同开发特色课程与教材。在第五届全国高等院校高尔夫冠军赛中获得佳绩，师生分别获得冠军和个人技能大赛一等奖。

          依托毗邻人工智能产业园的产业集群优势，对接廊坊建设京津冀电子信息走廊的发展定位，在全国高校中率先开设了虚拟现实技术专业和人工智能专业，是新工科产学研联盟虚拟现实教育工作委员会成员，是全国虚拟现实技术专业建设方案及课程体系标准编制单位之一，有较强的教学、科研实力和行业服务能力，与企业互促互进、相互依存、共建协同创新中心，共同研发的720VR影院已落户圆明园。

          经济管理学院将四大会计事务所之一的安永公司培训课程嵌入人才培养方案，实行定制培养，每年都有几十名毕业生进入安永中国——北京分公司、大连和济南分公司。

          医学院实行“2+1+1”分段培养，本着早临床、多临床、反复临床的宗旨，第三学年把教室搬到医院，由学校教师和医院主任医师共同授课，实施人才培养主体的“双元化”，人才培养过程的“员工化”。在真实的职业情境中，培养学生行业实践能力，建立行业文化自觉。

          学校始终把服务地方经济社会发展，作为自身的责任和使命，寻找契合点，与区域创新发展同频共振。学校是京津冀博物馆协同发展推进工作办公室授予的：京津冀博物馆文化创意基地、京津冀博物馆研学游体验基地、京津冀文博教育培训基地；是廊坊市版权服务工作站、廊坊市文创版权孵化基地、廊坊市知识产权信息公共服务网点、是廊坊市文物保护修复基地、廊坊市中小学生研学游实践基地。与廊坊市广告协会联合成立廊坊市广告研究院，与廊坊市文物保护研究所共建文化遗产保护研究中心，与廊坊市广阳区文旅局共建非遗传承创新中心。

          学校秉承“人文、智慧、开放”的办学理念，以校企合作、产教融合为主要路径，努力提升对区域经济社会发展的贡献力，培养德智体美劳全面发展，具有创新精神、实践能力和人文素养的应用型人才，让每一位学子在与时俱进的河北东方学院扬起成长成才的理想风帆，逐梦远航！筑梦东方，圆梦东方！
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavTop from '../../components/comcomponents/NavTop.vue'

export default {
  components: {NavTop},
  data () {
    return {
      navItems: [
        { name: '首页', path:'/home'},
        { name: '学校简介', path:'/profiles'},
        { name: '现任领导' ,path: '/leader'},
        { name: '学院导航',path:'/nav' },
        { name: 'VR校园全景',path: '/vr' },

      ],
    };
  },
  mounted() {
    this.scrollToDiv();
  },
  methods: {
    openExternalLink(event) {
      // 阻止默认事件，防止a标签打开新页面
      event.preventDefault();
      // 使用window.location.href进行跳转
      window.location.href = event.target.href;
    },
    navigateTo(path) {
      this.$router.push(path);
    },
    scrollToDiv() {
      // 使用 $refs 访问目标 div 元素
      const targetElement = this.$refs.targetDiv;
      if (targetElement) {
        // 使用 window.scrollTo() 方法平滑滚动到 div
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: 'smooth'
        });
      }
    }
  }

}
</script>

<style lang="less">
.el-dropdown-link{
  color: #FFFFFF;
}
.link{
  text-decoration: none;
  color: #333;
}

.header_nav:hover{
  background-color: #9e070e;
  color: #fff;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
  height: 450px;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.center{
  margin: 0 auto;
  width: 1240px;
  display: flex;
  flex-direction: row;
}
.sidebar {
  text-align: center;
  width: 200px;
  height: 100vh;
  margin-right: 50px;
}
.right_box{
  width: 100%;
}
.sidebar h2 {
  font-size: 24px;
  margin-bottom: 20px;
}

.sidebar .nav {
  //background-color: #fafafa;
  transform: translateY(-40%);
  list-style: none;
  padding-bottom: 100px;
  background: linear-gradient(170deg, #fafafa 90%, #fff 10%);

}

.sidebar .nav li {
  cursor: pointer;
  margin-bottom: 5px;
  font-size: 16px;
  padding: 10px;
  transition: background-color 0.3s;
}

.sidebar .nav li:hover {
  color:#6a6a6a ;
  background-color: #eee;
}

.sidebar .nav li {
  color: #6a6a6a;
}

.content-section h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.content-section p {
  font-size: 16px;
  line-height: 1.6;
  color: #555;
}
.title{
  width: 150px;
  height: 50px;
  padding-top: 10px;
  border-bottom:3px solid #9e070e ;
}
.row{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.between{
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}
.border_bottom{
  border-bottom: 1px solid #cdcbcc;
}
.left_box{
  display: flex;
}
.left_title{
  background: linear-gradient(-170deg, #9e070e 50%, #fafafa 10%);
  height: 350px;
  padding: 40px 0 0 0;
  color: #FFFFFF;
  div:first-child{
    font-size: 30px;
    margin: 10px;
  }
  div:last-child{
    font-size: 15px;
  }
}
.right_link{
  color: #666;
  font-size: 14px;
}
.txt{
  padding: 40px 0;
  text-indent: 2em;
  line-height: 2em;

}

.nav:hover{
  background-color: #9e070e;
  color: #fff;
}
.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}
.dropdown_menu{
  transform: translate(0,-6%);
  width: 120px;
  .el-dropdown-menu__item{
    text-align: center;
  }
  .el-dropdown-menu__item:hover{
    background-color: #8d080e;
    color: #fff;
  }
}
.dropdown{

}
.dropdown:hover{
  background-color: #9e070e;
}

</style>



// WEBPACK FOOTER //
// src/views/Leader/index.vue